<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="row">
          <div class="col">
            <div class="card-header">
              <h4 class="card-title">Trade Applications</h4>
            </div>
            <div class="card-body">
              <DataTable endpoint="users/trade-application" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import DataTable from '@kaweb-ltd/admin-vue/DataTable.vue'

  export default {
    components: {
      DataTable
    },
    data () {
      return {
      }
    }
  }
</script>
<style>

</style>
